import { render, staticRenderFns } from "./PrimaryNav.vue?vue&type=template&id=2e0bf40c&"
import script from "./PrimaryNav.vue?vue&type=script&lang=ts&"
export * from "./PrimaryNav.vue?vue&type=script&lang=ts&"
import style0 from "./PrimaryNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NuxtLinkExternal: require('/tmp/build_453bf6d7/src/components/misc/NuxtLinkExternal.vue').default})
